import { useI18n } from "vue-i18n";
import { useDataDisplayConfig } from "@/shared/data-display-config/composable/data-display-config";
import { DataDisplayConfigId } from "@/shared/data-display-config/composable/data-display.model";

/**
 * Provides the display configuration of the documentation list, which drives both the dynamic
 * datafield fragments of the search queries and the mapping of a result node to its property items.
 *
 * Every document search composable resolves this dependency itself instead of receiving it from a
 * sibling composable. The underlying query runs with `fetchPolicy: "cache-first"` and identical
 * variables, so repeated calls are served from the Apollo cache without an additional request.
 *
 * @returns The display config result, its loading state and the property item mapper.
 */
export const useDocumentationDisplayConfig = () => {
    const { t } = useI18n();

    return useDataDisplayConfig(DataDisplayConfigId.documentSelection, t);
};
